import { render, staticRenderFns } from "./tenDatabase__order.vue?vue&type=template&id=40d629ed"
import script from "./tenDatabase__order.vue?vue&type=script&lang=js"
export * from "./tenDatabase__order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports